import { HttpException } from './http.exception';

export class HttpConflictException extends HttpException {}
